import React, { useContext, useState, useEffect, useRef } from "react"
import { reels, icons, lines } from "global.js"
import { GameContext } from "utils/game-context"
import { Container, Sprite } from "@inlet/react-pixi"
import { clamp, easeInOut, easeIn, easeOut, lerp, sas } from "utils/math"
import Reel from "components/reel"
import ActiveHighlighter from "components/active-highlighter"
import ReelItem from "components/reel-item"
import FadeIn from "components/fade-in"
import FadeOut from "components/fade-out"
import * as _ from "lodash"

const Reels = () => {
  const context = useContext(GameContext)
  const [counter, setCounter] = useState(0)
  const stateRefs = [1, 2, 3, 4, 5].map(x => useRef("stop"))
  const rollCache = useRef([0, 0, 0, 0, 0])
  const { roll, activeItems, activeLine, showedLines } = context.state

  return (
    <Container>
      {lines
        .filter((f, i) => activeLine === i || showedLines.includes(i))
        .flatMap((line, i) =>
          line.map((x, j) => (
            <FadeIn key={`${i}-${j}`}>
              <ReelItem
                x={j * 60}
                y={(x + 1) * 60}
                width={60}
                height={60}
                item={reels[j][sas(roll[j] + x - 1, reels[j].length)]}
              />
            </FadeIn>
          ))
        )}
      {roll.map((x, i) =>
        activeItems[i] ? (
          <FadeOut delay={750} key={i}>
            <ActiveHighlighter
              x={i * 60}
              y={(activeItems[i] - x + 2) * 60}
              item={reels[i][activeItems[i]]}
            />
          </FadeOut>
        ) : (
          <React.Fragment key={i} />
        )
      )}
    </Container>
  )
}

export default Reels
